import { CommonModule, NgOptimizedImage, CurrencyPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActionBtnComponent } from '@enginuity/core/molecules/action-btn/action-btn.component';
import { BadgesComponent } from '@enginuity/core/molecules/badges/badges.component';
import { getCurrencySymbol } from '@services/core-services/utils';

@Component({
  selector: 'app-product-block',
  templateUrl: './product-block.component.html',
  styleUrls: ['./product-block.component.scss'],
  imports: [CommonModule, BadgesComponent, ActionBtnComponent, NgOptimizedImage],
  providers: [CurrencyPipe],
})
export class ProductBlockComponent {
  @Input() product!: any;
  @Input() editAction: boolean = false;
  @Input() deleteAction: boolean = false;
  @Input() showBadge = true;
  @Output() custon_click = new EventEmitter();

  constructor(private readonly currencyPipe: CurrencyPipe) {}

  get currencySymbol() {
    return getCurrencySymbol(this.currencyPipe);
  }
}
